define(function(require) {
	const tpl = require('./t_mv_view_documents.hbs');
	const ViewManager = require('civicsUtils/view_manager');
	const DocumentView = require('civicsViews/view_documents/v_itv_view_document.js');
	const Radio = require('backbone.radio');
  const ReportChannel = Radio.channel('reportChannel');

	return Marionette.CompositeView.extend({
		template:tpl,
		className:'view-documents-modal',
		childViewContainer: '.report-types',
		childView: DocumentView,
		childViewOptions: function() {
			return {
				modalRegion: this.modalRegion,
				inModalView: true,
			}
		},
		childEvents: {
			'openConfirmationModal': 'openConfirmationModal',
			'error:loading': 'displayError'

		},
		ui:{
			cancelButton:'.cancel-button',
			documentsList:'.report-types-list',
			closeModalButton: '.bbm-btn-close',
			errorRegion: '.error-region'
		},
		events:{
			'click @ui.cancelButton':'cancelClicked',
			'click @ui.closeModalButton':'cancelClicked'
		},
		onRender: function(){
			this.ui.errorRegion.hide();
		},
		initialize:function(options){
			this.reportTypes = options.reportTypes;
			this.modalRegion = options.modalRegion;
			this.collection = new Backbone.Collection(this.reportTypes);
		},
		displayError: function() {
			this.ui.errorRegion.show();
		},
		cancelClicked:function(){
			this.modalRegion.hideModal();
			return false;
		},
		openConfirmationModal: function(childView) {
			ReportChannel.trigger('openConfirmationModal', childView.model)
		},
		templateHelpers:function(){
			return {
				headerTitle: i18n.t('CIVICS.COMMON.MY_DOCUMENTS_MODAL_TITLE') + ' (' + this.reportTypes.length + ')'
			}
		}
	})
});
